export function distinct(arr) {
  let list = [];
  arr.forEach(element => {
    if (!list.hasOwnProperty(element)) {
      list[element] = element;
    }
  });
  return Object.values(list);
};
